//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            Loading: false,
            sharing: false,
            check_role: false,
            selectedProperty: {},
            selectedShareProperty: {},
            person: [],
            availableUnits: [],
            unitsForOptions: [],
            properties: [],
            person_status: '',
            errorMessage: null,
            applicantInfo: {
                unit: null,
                rent: 0
            },
            follow_ups_lenght: 0,
            EditGust: false,
            GuestDataLoading: false,
            loading: false,
            // contact_preferences: ['SMS', 'Email', 'Phone', 'Mail'],
            sources: ['Drive by', 'Resident referral', 'Former resident referral', 'Employee referral', 'Other word of mouth', 'Other Community referral', 'Google', 'Property website', 'Zillow', 'Trulia', 'Costar', 'Rentpath', 'Craigs list', 'Facebook Marketplace', 'Apartment Locator service', 'Flyer, Radio, Newspaper advertisement'],
            pet_breeds: ['Pit Bull Terriers', 'Staffordshire Terriers', 'Rottweilers', 'German Shepherds', 'Presa Canarios', 'Chows Chows', 'Doberman Pinschers', 'Akitas', 'Wolf-hybrids', 'Mastiffs', 'Cane Corsos', 'Great Danes', 'Alaskan Malamutes', 'Siberian Huskies']

        };
    },

    methods: {
        addShowing: function addShowing() {
            Event.$emit('add-showing-guest-card');
            Event.$emit('show-small-modal', false, false, 'add-showing');
        },
        shareGuest: function shareGuest() {
            Event.$emit('show-small-modal');
        },
        showCalculator: function showCalculator() {
            Event.$emit('show-move-in-calculator', this.person, this.selectedProperty, this.unitsForOptions);
        },
        sendShare: function sendShare() {

            var self = this;

            var sendData = {
                id: this.person.id,
                property: this.selectedShareProperty.id
            };

            window.axios.post('/prototype/person/guest-card/share', sendData).then(function (response) {
                self.sharing = !self.sharing;
                Event.$emit('close-small-modal');
            });
        },
        convertToApplicant: function convertToApplicant() {
            var _this = this;

            var $el = this;

            this.errorMessage = null;

            if (!this.applicantInfo.rent && !this.applicantInfo.unit) {

                this.errorMessage = 'Please include a unit and rent amount to convert this guest';

                return false;
            }
            this.loading = true;
            var sendData = {
                unit: this.applicantInfo.unit.value,
                nestio_unit_id: this.applicantInfo.unit.nestio_unit_id ? this.applicantInfo.unit.nestio_unit_id : '',
                rent: this.applicantInfo.rent
            };

            axios.post('/prototype/person/person-convert-to-applicant/' + $el.person.id, sendData).then(function (response) {
                Event.$emit('person-updated');
                _this.$snotify.success('The applicant was converted');
                Event.$emit('person-updated');
                Event.$emit('guest-card-dashboard-updated');
                Event.$emit('close-full-modal');
                Event.$emit('person-archive-updated');

                _this.loading = false;
            });
        },
        getAvailableUnits: function getAvailableUnits() {

            var self = this;

            window.axios.get('/prototype/properties/nestio-available-units').then(function (response) {

                self.availableUnits = response.data.filter(function (unit) {
                    return unit.status != 'Pending Approval';
                });

                var output = [];

                self.availableUnits.forEach(function (u) {

                    var item = {
                        label: u.name,
                        value: u.id,
                        nestio_unit_id: u.nestio_unit_id,
                        rent: u.market_rent_amount && parseFloat(u.market_rent_amount) > 0 ? u.market_rent_amount : u.rent_amount
                    };

                    output.push(item);
                });

                self.unitsForOptions = output;
            });
        },
        changeRentAmount: function changeRentAmount(val) {

            this.$set(this.applicantInfo, 'unit', val);
            this.$set(this.applicantInfo, 'rent', val.rent);
        },
        updateGuestCard: function updateGuestCard() {
            var $el = this;
            this.EditGust = false;
            this.Loading = true;
            this.GuestDataLoading = true;
            this.person.property = this.selectedProperty.id;
            this.person.prospect_id = this.person.prospect ? this.person.prospect.id : 0;
            axios.put('/prototype/person/' + this.person.id, this.person).then(function (response) {
                if (response.data) {
                    $el.person = response.data;
                    $el.person.nestio_id = $el.person.prospect ? $el.person.prospect.nestio_id : 0;
                    Event.$emit('person-updated');
                    Event.$emit('guest-card-dashboard-updated');
                    $el.GuestDataLoading = false;
                    $el.Loading = false;
                }
            });
        },
        addFollowUp: function addFollowUp() {
            var $el = this;
            Event.$emit('add-follow-up', $el.person);
        },
        changeStatus: function changeStatus($status) {
            var _this2 = this;

            var form = document.querySelector('form');
            var formData = new FormData(form);
            formData.append("status", $status);
            formData.append("id", this.person.id);
            axios.post('/prototype/person/guest-cards/changeStatus', formData).then(function (response) {
                if (response.data) {
                    _this2.$snotify.success('The status was updated');
                    Event.$emit('guest-card-dashboard-updated');
                    Event.$emit('person-archive-updated');
                    Event.$emit('person-updated');
                    Event.$emit('close-full-modal');
                }
            });
        },
        getCount: function getCount(item) {

            if (!item) {
                return 0;
            }

            return item.length;
        },
        viewGuestCard: function viewGuestCard(item) {
            var $el = this;

            $el.$children[0].$data.showModal = true;
            $el.person = item;
            $el.follow_ups_lenght = item.follow_ups.length;
            $el.selectedProperty = item.property ? { id: item.property.id, name: item.property.name } : '';
            $el.selectedShareProperty = $el.selectedProperty;
            axios.get('/prototype/guest-cards/' + $el.person.id).then(function (response) {
                $el.person = response.data;
                $el.person.nestio_id = $el.person.prospect ? $el.person.prospect.nestio_id : 0;
                $el.person.selected_agent = item.leasing_agent ? { 'id': item.leasing_agent.id, 'label': '(' + item.leasing_agent.id + ') ' + item.leasing_agent.first_name + ' ' + item.leasing_agent.last_name } : '';
                $el.person_status = response.data.status.status === "Archive" ? "Unarchive" : "Archive";
                $el.check_role = window.user.role === 'super-admin';
            });

            $el.getAvailableUnits();
        },
        getProperties: function getProperties() {
            var _this3 = this;

            axios.get('/prototype/get-properties').then(function (response) {
                _this3.properties = response.data;
            });
        },
        getUsers: function getUsers() {
            var _this4 = this;

            axios.get('/prototype/users/all').then(function (response) {
                _this4.users = response.data;
            });
        }
    },
    created: function created() {
        var _this5 = this;

        Event.$on('view-guest-card', function (item) {
            _this5.getProperties();
            _this5.viewGuestCard(item);
            _this5.getUsers();
        });

        Event.$on('status-updated', function () {
            $el.$children[0].$data.showModal = true;
            _this5.$snotify.success('The status was updated');
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('view-guest-card');
        Event.$off('status-updated');
    },

    computed: {
        leasingAgents: function leasingAgents() {

            return this.users.map(function (u) {
                return {
                    label: '(' + u.id + ') ' + u.first_name + ' ' + u.last_name,
                    id: '' + u.id
                };
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/guest-cards/GuestCardDetails.vue
// module id = p/P7
// module chunks = 0 1